import { Route } from '../config/routes';
import isEmpty from 'lodash/isEmpty';

export interface IPermissionsEvaluationDecision {
    permissionsShouldBeEvaluated: boolean;
    hasAction: boolean;
}

export const permissionsEvaluationDecision = (hash: string, route: Route): IPermissionsEvaluationDecision => {
    const hasExactPath = route.exactPath === true;
    const withActionEvaluation = !!route.actionType && route.canActivate && hash.startsWith(route.BASE);
    const defaultEvaluation = hash.startsWith(route.BASE) && !isEmpty(route.PERMISSIONS);
    const withExactPathEvaluation = hash === route.BASE;

    return {
        permissionsShouldBeEvaluated: hasExactPath ? withExactPathEvaluation : defaultEvaluation,
        hasAction: withActionEvaluation,
    };
};
